export default __webpack_public_path__ + "static/media/031-shopping-carts.ff0f547e.png";